import {
  API_CONVERSATION_DETAILS,
  API_CONVERSATION_MESSAGE_ATTACHMENT_DELETE,
  API_CONVERSATION_MESSAGE_ATTACHMENT_DOWNLOAD,
  API_CONVERSATION_MESSAGE_ATTACHMENT_UPLOAD,
  API_CONVERSATION_REPLY,
  API_CONVERSATION_REPLY_NO_ID,
  API_CONVERSATIONS
} from '../../config/urls';
import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';

import {UrlService} from '@shared/services/url.service';
import {ConversationsListConversationDTO} from '@dto/messaging/conversations-list-conversation-dto.model';
import {ConversationDetailMessageDTO} from '@dto/messaging/conversation-detail-message-dto.model';
import {ConversationReplyRequestDTO} from '@dto/messaging/conversation-reply-request-dto.model';
import {FlowAttachmentSasResponseDto} from '@dto/files/flow-attachment-sas-response.dto';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  /**
   * Gets all conversations for the current user
   */
  getConversations(): Observable<ConversationsListConversationDTO[]> {
    return this.http.get<ConversationsListConversationDTO[]>(API_CONVERSATIONS);
  }

  /**
   * Gets details of a specific conversation
   */
  getConversation(conversationId: string): Observable<ConversationDetailMessageDTO[]> {
    const endpointUrl = this.urlService.buildUrl(API_CONVERSATION_DETAILS, conversationId);
    return this.http.get<ConversationDetailMessageDTO[]>(endpointUrl);
  }

  /**
   * Sends a reply to an existing conversation, or creates a new conversation if conversationId is null
   */
  sendMessage(conversationId: string | null, messageDetails: ConversationReplyRequestDTO): Observable<void> {
    const endpointUrl = conversationId === null
      ? API_CONVERSATION_REPLY_NO_ID
      : this.urlService.buildUrl(API_CONVERSATION_REPLY, conversationId);
    return this.http.post<void>(endpointUrl, messageDetails);
  }

  requestUploadSas(conversationId: string, messageNumber: number, attachmentNumber: number, filename: string): Observable<FlowAttachmentSasResponseDto> {
    const endpointUrl = this.urlService.buildUrl(API_CONVERSATION_MESSAGE_ATTACHMENT_UPLOAD, conversationId, messageNumber.toString(), attachmentNumber.toString());
    return this.http.post<FlowAttachmentSasResponseDto>(endpointUrl, {filename: filename});
  }

  requestDownloadSas(conversationId: string, messageNumber: number, attachmentNumber: number, filename: string): Observable<FlowAttachmentSasResponseDto> {
    const endpointUrl = this.urlService.buildUrl(API_CONVERSATION_MESSAGE_ATTACHMENT_DOWNLOAD, conversationId, messageNumber.toString(), attachmentNumber.toString());
    return this.http.post<FlowAttachmentSasResponseDto>(endpointUrl, {filename: filename});
  }

  requestDeleteSas(conversationId: string, messageNumber: number, attachmentNumber: number, filename: string): Observable<void> {
    const endpointUrl = this.urlService.buildUrl(API_CONVERSATION_MESSAGE_ATTACHMENT_DELETE, conversationId, messageNumber.toString(), attachmentNumber.toString());
    return this.http.post<void>(endpointUrl, {filename: filename});
  }
}
